export type SurveyFillTranslation = {
  backToCertification: string;
  finish: string;
  label: string;
  loading: string;
  next: string;
  notFound: string;
  openAnswer: {
    label: string;
  };
  progress: string;
  progressLabel: string;
  questionCounter: string;
  questionLabel: string;
  submitting: string;
  summary: {
    allCategoriesMet: string;
    answer: string;
    backToCertification: string;
    categoriesCount_few?: string;
    categoriesCount_many?: string;
    categoriesCount_one: string;
    categoriesCount_other: string;
    competencyWorkRequired: string;
    goToResources: string;
    greatJob: string;
    howToImprove: string;
    intro: string;
    introGapsHint: string;
    loading: string;
    questionNumber: string;
    procedure: string;
    questionsCount_few?: string;
    questionsCount_many?: string;
    questionsCount_one: string;
    questionsCount_other: string;
    supportMaterials: string;
    title: string;
    viewAnswers: string;
  };
  unavailable: {
    cancelled: string;
    completed: string;
    deadlineExpired: string;
    title: string;
  };
};

export const surveyFillTranslation: SurveyFillTranslation = {
  backToCertification: 'Back to Certification',
  finish: 'Finish',
  label: 'Survey',
  loading: 'Loading survey...',
  next: 'Next',
  notFound: 'Survey not found',
  openAnswer: {
    label: 'Your answer ({{length}}/1000)',
  },
  progress: 'Progress: {{percent}}%',
  progressLabel: 'Progress',
  questionCounter: 'Question {{current}} of {{total}}',
  questionLabel: 'Question {{number}}',
  submitting: 'Saving...',
  summary: {
    allCategoriesMet: 'You met all competency thresholds. Keep up the great work!',
    answer: 'Answer',
    backToCertification: 'Back to Certification',
    categoriesCount_one: '{{count}} category requires attention',
    categoriesCount_other: '{{count}} categories require attention',
    competencyWorkRequired: 'Areas to develop',
    goToResources: 'Go to resources',
    greatJob: 'Great job!',
    howToImprove: 'How to improve',
    intro:
      "You have completed the first important stage of the certification process. Thank you for your honest self-assessment — this is a good starting point for further development and for strengthening the operational standards that directly affect our customers' experience in stores.",
    introGapsHint:
      'Below you will find the areas where it is worth deepening your knowledge or skills. Focusing on them will help you to be even better prepared for the next stages of the certification process.',
    loading: 'Loading results...',
    questionNumber: 'Question #{{number}}: ',
    procedure: 'Procedure',
    questionsCount_one: '{{count}} question',
    questionsCount_other: '{{count}} questions',
    supportMaterials: 'Support materials',
    title: 'Survey Results',
    viewAnswers: 'View your answers',
  },
  unavailable: {
    cancelled: 'This survey has been cancelled and can no longer be started or continued.',
    completed: 'This survey has been completed and can no longer be started or continued.',
    deadlineExpired:
      'The deadline for this survey has passed and it can no longer be started or continued.',
    title: 'Survey unavailable',
  },
};
